// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.contmap {\n  position: relative;\n  height: 370px;\n}\n.discinfo {\n  position: absolute !important;\n  bottom: 215px;\n  /* font-size: 15pt; */\n  right: 45px;\n}\n.exminpt {\n  font-size: 1rem;\n}\n.names {\n  fill: none;\n  stroke: #fff;\n  stroke-linejoin: round;\n}\n.details {\n  color: black;\n}\n.darkTheme .details {\n  color: white;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
